// extracted by mini-css-extract-plugin
export default {"page__container":"rain_page__container__VwB34"};